import AutoPurchasableProductLicense from "interfaces/response/AutoPurchasableProductLicense";
import AutoPurchasableProductLicenseDataForDrpodown from "interfaces/response/AutoPurchasableProductLicenseDataForDrpodown";
import { useEffect } from "react";
import { connect } from "react-redux";
import { getConfiguration } from "shared/utility/ConfigUtility";
import { convertToInternationalNumberSystem } from "shared/utility/NumberUtility";
import { getAutoPurchasableProductLicense } from "store/slices/ProductLicenseManagementSlice";
import { AppDispatch, RootState } from "store/store";
import ContactSalesFormWithButton from "./ContactSalesFormWithButton";
import LandingPageHeading from "./LandingPageHeading";
import EnterprisePlanCard from "./subscription-plans/EnterprisePlanCard";
import FreePlanCard from "./subscription-plans/FreePlanCard";
import PredefinedSubscriptionPlanCard from "./subscription-plans/PredefinedSubscriptionPlanCard";

interface Props {
  dispatch: AppDispatch;
  defaultFreeLicense: AutoPurchasableProductLicense | undefined;
  autoPurchasableProductLicense: AutoPurchasableProductLicenseDataForDrpodown[];
}

export function PlansAndPricing(props: Props) {
  const { dispatch, defaultFreeLicense, autoPurchasableProductLicense } = props;
  
  useEffect(() => {
    const defaultProductId = getConfiguration("defaultProductId");

    dispatch(getAutoPurchasableProductLicense(defaultProductId));
  }, [dispatch]);

  const PaymentInstruction = () => {
    return (
      <div className="max-w-52 font-medium">
        Our payments are conducted through the{" "}
        <span className="font-bold">Stripe</span> payment platform. For
        alternatives, such as payment by bank transfer and invoice, please
        <div>
          <ContactSalesFormWithButton type="link" />
        </div>
      </div>
    );
  };

  return (
    <div>
      <LandingPageHeading text="Plans & pricing" />
      <p className="font-medium leading-7 my-35px">
        We use a point based pricing model: you pay per API action, no more, no
        less. Choose a plan that fits your needs, or start with our free forever
        deal, and try timePhasing with a limited number of free actions / day.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-8">
        <div className="flex justify-center">
          <FreePlanCard defaultFreeLicense={defaultFreeLicense} />
        </div>
        <div className="flex justify-center">
          <PredefinedSubscriptionPlanCard autoPurchasableProductLicense={autoPurchasableProductLicense} />
        </div>
        <div className="flex justify-center">
          <EnterprisePlanCard />
        </div>
        <div className="hidden lg:block">
          <PaymentInstruction />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  var defaultFreeLicense: AutoPurchasableProductLicense | undefined ;
  var autoPurchasableProductLicense: AutoPurchasableProductLicenseDataForDrpodown[] = [] ;

  if (state.productLicenseManagementData.autoPurchasableProductLicense) {
    state.productLicenseManagementData.autoPurchasableProductLicense.forEach((license) => {
      if (license.isDefaultFreeLocalLicense) {
        defaultFreeLicense = license;
      }
      else {
        var autoPurchasableProductLicenseDataForDrpodown : AutoPurchasableProductLicenseDataForDrpodown = {
          id: license.id,
          title: `${convertToInternationalNumberSystem(license.numberOfAllowedActions ? license.numberOfAllowedActions : 0)} / ${license.actionValidationDurationUnitText?.toLowerCase()}`, 
          price: `${license.price?.toString()}`
        };
  
        autoPurchasableProductLicense.push(autoPurchasableProductLicenseDataForDrpodown);
      }
    });
  }

  return {
    ...props,
    defaultFreeLicense,
    autoPurchasableProductLicense
  }
};

export default connect(mapStateToProps)(PlansAndPricing);